import {HTTP} from "@/http";

class TenantService {
  basePath = 'api/v2/admin/tenants';
  selfBasePath = 'api/v2/tenants';

  // Standard tenant operations (self)
  getSelf() {
    return HTTP.get(`${this.selfBasePath}/self`);
  }

  patchSelf(tenant) {
    return HTTP.patch(`${this.selfBasePath}/self`, tenant);
  }

  // Admin tenant operations
  get() {
    return HTTP.get(this.basePath);
  }

  setActive(tenantId, isActive) {
    return HTTP.post(`${this.basePath}/${tenantId}/active`, { active: isActive });
  }

  getById(id) {
    return HTTP.get(`${this.basePath}/${id}`);
  }

  create(tenant) {
    return HTTP.post(this.basePath, tenant);
  }

  patch(tenantId, tenant) {
    return HTTP.patch(`${this.basePath}/${tenantId}`, tenant);
  }

  delete(tenantId) {
    return HTTP.delete(`${this.basePath}/${tenantId}`);
  }

  // Tenant Account operations
  getTenantRootAccounts(tenantId) {
    return HTTP.get(`${this.basePath}/${tenantId}/root-accounts`);
  }

  getTenantAccounts(tenantId, filterParams = {}, pageParams = {}) {
    const params = { ...filterParams, ...pageParams };
    return HTTP.get(`${this.basePath}/${tenantId}/accounts`, { params });
  }

  createTenantAccount(tenantId, account) {
    return HTTP.post(`${this.basePath}/${tenantId}/accounts`, account);
  }

  // Tenant Customer operations
  getAllCustomers() {
    return HTTP.get(`${this.basePath}/customers`);
  }

  getCustomersByTenant(tenantId) {
    return HTTP.get(`${this.basePath}/${tenantId}/customers`);
  }

  createCustomer(tenantId, customer) {
    return HTTP.post(`${this.basePath}/${tenantId}/customers`, customer);
  }

  deleteCustomer(tenantId, customerId) {
    return HTTP.delete(`${this.basePath}/${tenantId}/customers/${customerId}`);
  }

  // Global account management
  createAccount(account) {
    return HTTP.post('api/v2/admin/accounts', account);
  }
}

/**
 * @type {TenantService}
 */
export const tenantService = new TenantService();
